import { i18n } from '@lingui/core';
import { IconBookmark16 } from '@warp-ds/icons/react/bookmark-16';
import { Button } from '@warp-ds/react';
import React from 'react';

type SavedSearchButtonProps = {
    className?: string;
    disabled?: boolean;
    onClick?: () => void;
};

export function SavedSearchButton(props: SavedSearchButtonProps) {
    const { className = '', disabled = false, onClick } = props;

    return (
        <Button
            className={`${className} flex items-center space-x-8`}
            disabled={disabled ?? undefined}
            onClick={onClick}
        >
            <IconBookmark16 />
            <span className="hidden md:inline">
                {i18n.t({
                    id: 'saved-search.button.open',
                    message: 'Save search',
                })}
            </span>
        </Button>
    );
}
